import { Routes, Route } from 'react-router-dom';
import { Layout } from '@/components/Layout';
import { EvaluationNew } from '@/pages/EvaluationNew';
import { EvaluationDashboard } from '@/pages/EvaluationDashboard';
import { CriteriaBuilder } from '@/pages/CriteriaBuilder';
import { ParticipantManager } from '@/pages/ParticipantManager';
import { Scorecard } from '@/pages/Scorecard';
import { EvaluationResultsPage } from '@/pages/EvaluationResultsPage';
import { NotFound } from '@/pages/NotFound';
import { Home } from './pages/Home';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="evaluation/new" element={<EvaluationNew />} />
        <Route path="evaluation/:id" element={<EvaluationDashboard />} />
        <Route path="evaluation/:id/criteria" element={<CriteriaBuilder />} />
        <Route path="evaluation/:id/participants" element={<ParticipantManager />} />
        <Route path="evaluation/:id/results" element={<EvaluationResultsPage />} />
        <Route path="evaluation/:evaluationId/scorecard/:solutionId/:participantId" element={<Scorecard />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}

export default App;
